/** Presentation-only mounted rat proportions; movement and collision remain server rules. */
export const goblinRatMorph = { width: 1, height: 1, length: 1, headSize: 1, earSize: 1, tailLength: 1, riderElevation: .2, stride: 4.6 };
